import Vue from 'vue';
import Router from 'vue-router';
import NotFound from '@/views/error/404';
import RouterSection from '@/Layout/components/RouterSection';
import PanchokNotFound from '@/views/panchok/NotFound';

// 내부 router들 정의
import login from './modules/login';
import ggoodsList from './modules/ggoodsList';
import orderList from './modules/orderList';
import orderSendList from './modules/orderSendList';
import estimateList from './modules/estimateList';
import myBiz from './modules/mybiz';
import bizshop from './modules/bizShop';
import cs from './modules/cs';
import companyList from './modules/companyList';
import guide from './modules/guide';
import survey from './modules/survey';
import email from './modules/email';
import surveyOrderDefault from './modules/surveyOrderDefault';
import surveyOrderLottery from './modules/surveyOrderLottery';
import msgsvc from './modules/msgsvc';
import promotionLanding from './modules/promotion';
import selectedCoupon from './modules/selectedCoupon';

import beforeHook from './beforeHook';
import afterHook from './afterHook';
import scrollBehavior from './scrollBehavior';

import panchokList from '@/router/modules/panchokList';

Vue.use(Router);

/**
 * name 작성 시 유념 사항
 * 1. name은 고유 값이어야 합니다.
 * 2. router 내 name과  내부의 name은 동일해야 합니다.
 */

const router = new Router({
	// router 이동시 scroll 위로
	scrollBehavior,
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: RouterSection,
			mode: 'history',
			redirect: { name: 'Mhowsbizhome' },
			// Main Contents UI
			children: [
				{
					path: 'home',
					name: 'Mhowsbizhome',
					component: () => import('@/views/Home'),
					beforeEnter(to, from, next) {
						let urlParams = new URLSearchParams(location.search);
						let bzTrackingId = '';
						if (urlParams.get('bz_tracking_id')) {
							bzTrackingId = urlParams.get('bz_tracking_id');
						}
						urlParams.delete('bz_tracking_id');
						urlParams.append('bz_tracking_id', bzTrackingId);
						next();
					},
				},
				// 회원가입 > 사업자등록번호
				{
					path: 'join',
					name: 'join',
					component: () => import('@/views/member/Join'),
					props: route => ({ isPromotionJoin: String(route.query.isPromotionJoin).toLowerCase() === 'true' }),
					children: [
						// 회원가입 > 기본정보
						{
							path: 'basicinformation',
							name: 'basicinformation',
						},
					],
				},
				// 회원가입 > 회원가입완료
				{
					path: 'joinfinish',
					name: 'joinfinish',
					component: () => import('@/views/member/Join/JoinFinish'),
				},
				// 검색결과
				{
					path: 'search',
					name: 'search',
					component: () => import('@/views/search/Searchlist'),
					props: true,
				},
				// 마케팅 계산기 검색 결과
				{
					path: 'search/marketing',
					name: 'marketingSearch',
					component: () => import('@/views/search/Mrkresult'),
				},
				// 비즈특가
				{
					path: 'specialprice',
					name: 'specialprice',
					component: () => import('@/views/specialprice/SpecialPrice'),
				},
				// 혜택존
				{
					path: 'allianceZone',
					name: 'allianceZone',
					component: () => import('@/views/partnership/AllianceList'),
					beforeEnter: (to, from, next) => {
						// 필터가 열린 상태로 진입시 필터 닫기
						if (to?.query?.filter) {
							next({ ...to, query: { ...to.query, filter: undefined } });
							return;
						}
						next();
					},
				},
				// 제휴혜택존 상세
				{
					path: 'allianceDetail',
					name: 'allianceDetail',
					component: () => import('@/views/partnership/AllianceDetail'),
				},
				// 로그인하지 않아도 연결이 가능한 페이지
				// 공통 단독페이지 - 리뉴얼
				{
					path: 'checkguide',
					name: 'checkguide',
					component: () => import('@/views/error/CheckGuide'),
					meta: { whitePage: true },
				},
				//공통 단독페이지 - 점검 공지
				{
					path: 'systemBlock',
					name: 'systemBlock',
					component: () => import('@/views/error/SystemBlock'),
					meta: { whitePage: true },
				},
				// 회원정보 관리 - 탈퇴완료
				{
					path: 'memberInfowithdrawalend',
					name: 'memberInfowithdrawalend',
					component: () => import('@/views/mybiz/MemberInfo/MemberInfoWithdrawalEnd'),
				},
			],
		},
		login,
		ggoodsList,
		orderList,
		estimateList,
		myBiz,
		bizshop,
		orderSendList,
		cs,
		companyList,
		panchokList,
		guide,
		survey,
		email,
		surveyOrderDefault,
		surveyOrderLottery,
		msgsvc,
		promotionLanding,
		selectedCoupon,
		{ path: '/panchok/*', name: '404', component: PanchokNotFound },
		{ path: '*', name: '404', component: NotFound },
	],
});

router.beforeEach(beforeHook);
router.afterEach(afterHook);

export default router;
